import styled from 'styled-components';
import { Icon } from '../../../../../stories/atoms';
import { RowFlexContainer } from '../../../../../stories/atoms/containerV2/ContainerV2';

export const CircleSection = styled(RowFlexContainer)`
  background-color: ${({ theme: { color, palette } }) =>
    palette.mode === 'dark' ? color.backgroundPaperDark : color.white};
`;

export const StyledIcon = styled(Icon)`
  width: ${({ theme: { spacing } }) => spacing(3)};
  height: ${({ theme: { spacing } }) => spacing(3)};
`;
